import * as React from "react";
import {RangedDatePickerWithOptions} from "../../../../components/rangeddatepicker/RangedDatePickerWithOptions";
// tslint:disable-next-line:max-line-length
import RangedDatePickerWithOptionsController from "../../../../components/rangeddatepicker/RangedDatePickerWithOptionsController";
import {I18n} from "../../../../components/Utils/i18n";
import {borderRadius, ColorPalette, SpecificAlarmFilterProps} from "./Commons";

import {AppTranslations} from "../../../../components/Utils/translations/AppTranslations";
import "./PeriodFilter.scss";
import {themeDefaultValues} from "../../../../index";

declare var LOCALE: string;
declare var AppTranslations: AppTranslations;
export class PeriodFilter extends React.Component<SpecificAlarmFilterProps, any> {

    private allStatesAlarmPeriodControllers: RangedDatePickerWithOptionsController;

    constructor(props) {
        super(props);

        this.allStatesAlarmPeriodControllers = new RangedDatePickerWithOptionsController({});

        this.props.resetter((defaultOption) => {
            this.allStatesAlarmPeriodControllers.changeOption(defaultOption);
        });
    }

    public componentDidMount() {
        this.allStatesAlarmPeriodControllers.listen((range) => {
            const newFilter = {...this.props.filter};
            newFilter.received.lookupPeriod = range;
            this.props.onFilterConfigChanged(newFilter);
        });
    }

    public render() {
        return (
            <div className={"period-filter filter-form-column"}>
                <p className={"filter-field-name"}>{AppTranslations.equipmentAlarmFilter.receivedFrom}</p>
                <div className={"group-wrapper possible-states"}>
                    {this.renderPeriod(this.props.defaultOption)}
                </div>
            </div>
        );
    }

    private renderPeriod = (defaultOption: number) => {
        return (
            <div className={"row-box"}>
                <div className={"fit-parent"}>
                    <div
                        style={{
                            backgroundColor: themeDefaultValues.buttonBg,
                            borderRadius: themeDefaultValues.textButtnBorderRadius,
                            padding: "10px",
                        }}
                    >
                        <div className={"state-date-wrapper"} style={{paddingTop: "unset"}}>
                            <RangedDatePickerWithOptions
                                options={this.props.selectionOptions}
                                defaultOption={defaultOption}
                                controller={this.allStatesAlarmPeriodControllers}
                                periodLabel={AppTranslations.equipmentAlarmFilter.periodLabel}
                                fromLabel={AppTranslations.equipmentAlarmFilter.stateDateFromLabel}
                                toLabel={AppTranslations.equipmentAlarmFilter.stateDateToLabel}
                                customText={AppTranslations.equipmentAlarmFilter.customOptionLabel}
                                disabled={this.props.disabled}
                                dateFormat={I18n.getLocaleDateFormat(LOCALE)}
                                locale={LOCALE}
                                maxDate={new Date()}
                                useETUIcomponent={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
